import "../auth-modern.css";

export default function ShowDetailSignup({ text }) {
  return (
    <div className="auth-modern-help">
      <div className="auth-modern-help-box">
        <h4>{text}</h4>
      </div>
    </div>
  );
}
